import { render } from "./App.vue?vue&type=template&id=56454d47"
const script = {}

import exportComponent from "C:\\ecommerce\\WIKINI_B2B_VUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__